import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";


const apiUrl = process.env.REACT_APP_API_URL;

export const AjoutClient = ({ 
  setVisible,        
  setRescentCli,     
  onClose            
}) => {
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nom, setNom] = useState("");
  const [adresse, setAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");


  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [mail, setMail] = useState("");
  const [mail2, setMail2] = useState("");
  const [note, setNote] = useState("");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message,setMessage] = useState("");
  

  const searchTextFieldRef = useRef(null);

  useEffect(() => {
    if (searchTextFieldRef.current) {
      searchTextFieldRef.current.focus();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nom) {
      setMessage("Le nom du client est vide réessayer");
      setOpenSnackbar(true);
      return;
    }

    const data = {
      nom: nom,
      adresse: adresse,
      codePostal: codePostal,
      ville: ville,
      num1: num1,
      num2: num2,
      mail: mail,
      mail2: mail2,
      note: note,
      user: localStorage.getItem("us"),
    };

    setIsSubmitting(true);
    try {
      const response = await axios.put(`${apiUrl}IHM/api/`, data);
      
      // Retourner l'ID du client créé
      if (response.data && response.data.lastInsertedId) {
        setRescentCli(response.data.lastInsertedId);
      }
      
    setMessage("Le client a été ajouté");
    setOpenSnackbar(true);
      
      setTimeout(() => {
        
        setVisible(false);
        if (typeof onClose === "function") onClose();
      }, 1500);
    } catch (error) {
      setMessage("Erreur lors de l'insertion réessayer");
      setOpenSnackbar(true);
    } finally {
   
      setIsSubmitting(false);
    }
  };

  const handleNum1Change = (e) => {
    const inputValue = e.target.value.trimStart();
    if (/^[0-9+\s]*$/.test(inputValue)) {
      setNum1(inputValue);
    }
  };

  const handleNum2Change = (e) => {
    const inputValue = e.target.value.trimStart();
    if (/^[0-9+\s]*$/.test(inputValue)) {
      setNum2(inputValue);
    }
  };

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">Ajouter un client</span>
    </div>
  );

   const handleCloseSnackbar = () => {
    setMessage("");
    setOpenSnackbar(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={message}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "50vw", maxWidth: "700px" }}
        modal
        onHide={() => {
          setVisible(false);
          if (typeof onClose === "function") onClose();
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          <div className="grid">
            <div className="col-12">
              <div
                style={{
                  background: "#f3f4f6",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <span
                  style={{
                    background: "#374151",
                    color: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 700,
                  }}
                >
                  1
                </span>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#374151",
                    letterSpacing: "0.05em",
                  }}
                >
                  INFORMATIONS CLIENT
                </span>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="grid">
              <div className="col-12 md:col-6">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Nom *
                </label>
                <InputText
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  className="w-full"
                  style={{ height: "36px" }}
                  required
                  ref={searchTextFieldRef}
                />
              </div>
              <div className="col-12 md:col-6">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Ville
                </label>
                <InputText
                  value={ville}
                  onChange={(e) => setVille(e.target.value)}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Adresse
                </label>
                <InputText
                  value={adresse}
                  onChange={(e) => setAdresse(e.target.value)}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Code Postal
                </label>
                <InputText
                  value={codePostal}
                  onChange={(e) => setCodePostal(e.target.value)}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Téléphone 1
                </label>
                <InputText
                  value={num1}
                  onChange={handleNum1Change}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Téléphone 2
                </label>
                <InputText
                  value={num2}
                  onChange={handleNum2Change}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Email
                </label>
                <InputText
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Email 2
                </label>
                <InputText
                  value={mail2}
                  onChange={(e) => setMail2(e.target.value)}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label
                  style={{
                    fontSize: "12px",
                    color: "#374151",
                    display: "block",
                    marginBottom: "2px",
                  }}
                >
                  Note
                </label>
                <InputTextarea
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  rows={3}
                  className="w-full"
                  style={{ resize: "vertical" }}
                />
              </div>
            </div>

            <div className="grid mt-3">
              <div className="col-12">
                <Button
                  label="Ajouter le client"
                  icon="pi pi-check"
                  className="w-full"
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    background: "#0971b7",
                    border: "none",
                    padding: "0.75rem",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    justifyContent: "center",
                    gap: "8px",
                    color: "white",
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </>
  );
};